var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1673 10L17.134 7.675L17.4173 4.6L14.409 3.91667L12.834 1.25L10.0007 2.46667L7.16732 1.25L5.59232 3.90833L2.58398 4.58333L2.86732 7.66667L0.833984 10L2.86732 12.325L2.58398 15.4083L5.59232 16.0917L7.16732 18.75L10.0007 17.525L12.834 18.7417L14.409 16.0833L17.4173 15.4L17.134 12.325L19.1673 10ZM8.40898 13.9333L5.24232 10.7583L6.47565 9.525L8.40898 11.4667L13.284 6.575L14.5173 7.80833L8.40898 13.9333Z",
    fill: "#A37C51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserVerified);
export default __webpack_public_path__ + "static/media/UserVerified.769d00ad8b3c26cf11e077318513d31f.svg";
export { ForwardRef as ReactComponent };